import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import PageTemplate from './PageTemplate';
import TopBottom5Themes from './Components/TopBottom5Themes';
import EmployeeWiseTable from './Components/EmployeeWiseTable';
import AssessmentScore from './Components/AssessmentScore';
import AssessmentAddScore from './Components/AssessmentAddScore';
import AssessmentCategories from './Components/AssessmentCategories';
import AssessmentTop5 from './Components/AssessmentTop5';
import BrightBlindSpotTM from './Components/BrightBlindSpotTM';
import DominantFrequency from './Components/DominantFrequency';

class AssessmentReport extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();

    this.hindiPDFstatic = [...Array(700).keys()].map((index) => (React.createRef()))

    this.state = {
      crrSelectedEmp: "",
      crrIsOverall: false,
      languageName: 'English',
      languageShortName: 'en',
      showFilter: false,
      showValue: "",
      ListName: "",

      currFilterList: [],
      finalFilter: []

    }
  }

  componentDidMount() {

  }

  exportPDFWithComponent = async () => {
    if (this.state.languageShortName === 'hi') {
    } else {
      if (this.pdfExportComponent.current) {
        this.pdfExportComponent.current.save();
      }
    }
  };



  handleSelectEmployee = (value) => {
    let { onTeamAssessmentByEmpID } = this.props;
    let { finalFilter } = this.state;

    console.log("finalFilter--x1x-->", finalFilter)

    this.setState({ showValue: "", showFilter: false }, () => {

      if (value === "Overall") {
        let tempX = {
          "emp_id": "Overall",
          "name": "Overall"
        }
        this.setState({ crrSelectedEmp: tempX, crrIsOverall: true }, () => {
          onTeamAssessmentByEmpID(null, true, finalFilter);
        });

      } else {
        let emp_id = "";
        if (value && value.emp_id) {
          emp_id = value.emp_id;
        } else {
          emp_id = "";
        }
        this.setState({ crrSelectedEmp: value, crrIsOverall: false }, () => {
          onTeamAssessmentByEmpID(emp_id, false, finalFilter);
        });
      }

    });
  }

  handleLanguageLabel = (data) => {
    this.setState({
      languageName: data.name,
      languageShortName: data.shortName
    })
  }


  closeFilter = (check1, check2) => {
    this.setState({ showFilter: check1, showValue: check2 });
  }


  handleFilterCall = (finalFilter, name) => {
    let { handleFilterFn } = this.props;
    let { crrSelectedEmp, crrIsOverall } = this.state;
    this.setState({
      finalFilter: finalFilter,
      ListName: name,
      showMainPage: true
    });

    if (!(finalFilter && finalFilter.length > 0)) {
      this.setState({
        currFilterList: [],
        finalFilter: []
      });
    }

    let emp_id = null;
    if (!crrIsOverall) {
      if (crrSelectedEmp && crrSelectedEmp.emp_id) {
        emp_id = crrSelectedEmp.emp_id;
      }
    }

    handleFilterFn(4, emp_id, crrIsOverall, finalFilter);
  }


  render() {

    let { loading, EmpFilterData, createdAt, onDownloadAssessmentType2ByEmpID } = this.props;

    let {
      getAssessmentReportByEmpIDData,
      getAssessmentDimensionsData,
      getAssessmentDimensionsV3Data,

      getAllUserAssessmentByTeamIdData,

      getAssessmentTop5DescByNamesData,
      getTranslateElementAllData
    } = this.props;

    const getAllAnsweredAssessmentEmpDataList = getAllUserAssessmentByTeamIdData;

    console.log("1...getAssessmentReportByEmpIDData---x---x----x---x>", getAssessmentReportByEmpIDData)
    console.log("2...getAllUserAssessmentByTeamIdData---x---x----x---x>", getAllUserAssessmentByTeamIdData)

    let sortedAssessmentDimensions = [];


    let { currFilterList, finalFilter,
      crrIsOverall, languageName,
      languageShortName, crrSelectedEmp
    } = this.state;


    let EmpFilterData2 = []
    if (EmpFilterData && EmpFilterData.length > 0) {
      EmpFilterData.forEach((emp) => {
        if (emp.name !== 'ManagerPID') {
          EmpFilterData2.push(emp);
        }
      })
    }


    const GetTextByLanguage = (name, text) => {
      if (languageShortName && languageShortName !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][languageShortName] ? getTranslateElementAllData[getIndex]["transl"][languageShortName] : ""
          }
        }
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (languageShortName && languageShortName !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][languageShortName] && element["details"]["transl"][languageShortName][name] ?
          element["details"]["transl"][languageShortName][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }


    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }
    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }




    function matchDimension(parameterDimensionNames, topDimensions) {
      let check = false;
      let paraList = parameterDimensionNames.split(",");
      const intersection = paraList.filter(element => topDimensions.includes(element.trim()));
      if (intersection && intersection.length > 4) {
        check = true;
      } else {
        check = false;
      }
      return check
    }




    function getHeading(field, list1, list2) {

      let AssessmentList = []
      let topDimensions = [];

      if (list1 && list1.length > 0) {
        list1.forEach((element) => {
          AssessmentList.push({
            ...element,
            finalSum: (Number(element.count) * Number(element.rankSum))
          })
        })
        AssessmentList.sort((b, a) => (a.finalSum - b.finalSum))
      }
      if (AssessmentList && AssessmentList.length > 0) {
        AssessmentList.forEach((ele, index) => {
          if (index < 5) {
            topDimensions.push(ele.dimension);
          }
        })
      }





      let desc = "";
      if (list2 && list2.length > 0) {
        for (var x = 0; x < list2.length > 0; x++) {
          if (matchDimension(list2[x]["parameterDimensionNames"], topDimensions)) {
            desc = list2[x][field];
            break;
          }
        }
      }

      return desc
    }



    let managerName = crrSelectedEmp && crrSelectedEmp.name ? crrSelectedEmp.name : "Team";


    return (
      <div className='mx-auto lg:w-5/6 w-full border'>
        <div className="sticky top-0 z-40 border-b overflow-hidden overflow-y-auto bg-white ">
          <div className="flex flex-col lg:flex-row items-center justify-between p-4 px-6 gap-4">
            <div className="flex md:flex-row flex-col items-center gap-2 w-full md:w-auto">
              <h1 className="text-base font-semibold text-[#212121] md:text-lg">
                {EditButtonFn(
                  "TalentAssessmentReport",
                  "TalentPlusStrengths Assessment Report"
                )}
              </h1>

            </div>
            {getAssessmentDimensionsData?.length > 0 && (
              <button
                onClick={() => {
                  languageShortName !== "en"
                    ? onDownloadAssessmentType2ByEmpID(
                      this.state.crrSelectedEmp?.emp_id || "",
                      languageShortName
                    )
                    : this.exportPDFWithComponent();
                }}
                // onClick={() => sendPDFMail(languageShortName)}
                className="flex items-center py-3.5 px-4 text-sm border rounded-md font-medium text-[#212121] w-full md:w-auto"
              >
                <span className="material-symbols-outlined mr-2">
                  file_download
                </span>
                Download PDF
              </button>
            )}
          </div>
        </div>

        {true ?
          <div >
            <PDFExport ref={this.pdfExportComponent}
              pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
              scale={0.6}
              forcePageBreak=".page-break"
              paperSize="A4"
              margin={0}
              fileName={'Team Assessment Report'}
              author="Happyplus Team"
              landscape={false}
            >

              <div className=''>

                <AssessmentScore
                  managerName={managerName}
                  EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                  createdAt={createdAt}
                  hindiPDFstatic={{}}
                />

                <AssessmentTop5
                  managerName={managerName}
                  EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                  hindiPDFstatic={{}}
                />

                <AssessmentCategories
                  managerName={managerName}
                  getAssessmentDimensionsData={getAssessmentReportByEmpIDData}
                  EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                  createdAt={createdAt}
                  hindiPDFstatic={{}}
                />

                <AssessmentAddScore
                  managerName={managerName}
                  getAssessmentDimensionsData={getAssessmentReportByEmpIDData}
                  EditDetailsFn={EditDetailsFn} EditButtonFn={EditButtonFn}
                  createdAt={createdAt}
                  hindiPDFstatic={{}}
                />



                <main className="p-10 px-6 space-y-6 bg-white page-break">
                  <div className='page-break'>
                    <div className="flex items-center justify-between w-full py-4 border-b">
                      <h1 className="text-lg font-semibold">
                        {EditButtonFn(
                          "TalentAssessmentReport",
                          "Team TalentPlusStrengths Assessment Report"
                        )}
                      </h1>
                      <p className="text-lg font-semibold">
                        {managerName}
                      </p>
                    </div>

                    <div className='py-2 space-y-4'>
                      <p className='text-[#212121]/70'>{getHeading("desc", getAssessmentReportByEmpIDData, getAssessmentTop5DescByNamesData)}</p>
                      <p className='text-[#212121]/70'>
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              getHeading("desc1", getAssessmentReportByEmpIDData, getAssessmentTop5DescByNamesData),
                          }}
                        />
                      </p>

                      <h1 className="text-3xl text-[#212121]">Team Overview</h1>

                      <h1 className='text-xl font-medium text-[#212121]'>Team Dominant and Non Dominant Themes</h1>
                      <div className='flex flex-row gap-1'>
                        <TopBottom5Themes
                          getAssessmentDimensionsData={getAssessmentReportByEmpIDData}
                          EditDetailsFn={EditDetailsFn}
                          EditButtonFn={EditButtonFn}
                        />
                      </div>

                    </div>
                  </div>
                </main>


                {getAssessmentDimensionsV3Data && getAssessmentDimensionsV3Data.length > 0 ?
                  <DominantFrequency
                    getAssessmentDimensionsV3Data={getAssessmentDimensionsV3Data}
                    EditButtonFn={EditButtonFn}
                    managerName={managerName}
                    createdAt={createdAt}
                    loading={loading}
                  />
                  : null
                }


                {/* Teams's Bright & Blind Spots  */}
                {getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0 ?
                  <BrightBlindSpotTM
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    EditDetailsFn={EditDetailsFn}
                    EditButtonFn={EditButtonFn}
                    managerName={managerName}
                    createdAt={createdAt}
                    title={"Team's"}
                  />
                  : null}

                <EmployeeWiseTable
                  getAllAnsweredAssessmentEmpDataList={getAllAnsweredAssessmentEmpDataList}
                  getAssessmentDimensionsMngrData={sortedAssessmentDimensions}
                  getAssessmentDimensionsData={getAssessmentReportByEmpIDData}
                  EditDetailsFn={EditDetailsFn}
                  EditButtonFn={EditButtonFn}
                  managerName={managerName}
                  isTop={true}
                />

                <EmployeeWiseTable
                  getAllAnsweredAssessmentEmpDataList={getAllAnsweredAssessmentEmpDataList}
                  getAssessmentDimensionsMngrData={sortedAssessmentDimensions}
                  getAssessmentDimensionsData={getAssessmentReportByEmpIDData}
                  EditDetailsFn={EditDetailsFn}
                  EditButtonFn={EditButtonFn}
                  managerName={managerName}
                  isTop={false}
                />


              </div>

            </PDFExport>
          </div>
          : <div className='py-24 text-2xl font-bold text-center text-gray-500'>{"Loading..."}</div>}

      </div>
    );
  }
}
function mapStateToProps(state) {
  // //////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(AssessmentReport);
